import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {IMerchant} from './IMerchant';
import {NgxSpinnerService} from 'ngx-spinner';
import {MerchantsService} from './merchants-service';
import {HttpErrorValidator} from '../services/http-error-validator';
import {Router} from '@angular/router';
import {MerchantListComponent} from './merchant-list.component';
import * as $ from 'jquery';

@Component({
  selector: 'pm-merchant',
  templateUrl: './merchant.component.html',
  styleUrls: ['./merchant.component.sass']
})
export class MerchantComponent implements OnInit, OnDestroy, AfterViewInit {

  comercios: IMerchant[] = [];
  comerciosFiltrados: IMerchant[] = [];
  currentPg = 1;

  constructor(private spinnerService: NgxSpinnerService, private parent: MerchantListComponent, private router: Router,
              private comerciosService: MerchantsService,
              private httpErrorValidator: HttpErrorValidator) {
  }

  ngOnInit(): void {
    this.spinner();
    this.comerciosService.getComercios().subscribe(response => {
      this.comercios = response;
      this.comerciosFiltrados = response;
    }, err => this.httpErrorValidator.validateError(err));
  }

  newComercio(): void {
    this.parent.showEditComercios = false;
    this.parent.showComercios = false;
    this.parent.showAddComercios = true;
    this.parent.showEditRolComercios = false;
    this.parent.showModalComercios = false;
  }

  searchComercio(): void {
    this.parent.showEditComercios = false;
    this.parent.showComercios = false;
    this.parent.showAddComercios = false;
    this.parent.showEditRolComercios = false;
    this.parent.showModalComercios = true;
  }

  edit(elemento, index: number) {
    this.parent.editnumber = elemento.id;
    this.parent.showEditComercios = true;
    this.parent.showComercios = false;
    this.parent.showAddComercios = false;
    this.parent.showEditRolComercios = false;
    this.parent.showModalComercios = false;
  }

  public spinner(): void {
    this.spinnerService.show();
    setTimeout(() => {
      this.spinnerService.hide();
    }, 300);
  }

  ngOnDestroy() {
    $('a[rel=comercios]').removeClass('selected');
  }

  ngAfterViewInit() {
    $('a[rel=comercios]').addClass('selected');
  }
}
